import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  z-index: 1000;
  transform: translate(-50%, -100%);
`

const Label = styled.span`
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: ${rem(4)};
  padding: ${rem(4)} ${rem(8)};
  background: rgba(255, 255, 255, 0.95);
  border-radius: ${props => props.theme.borderRadius.M};
  font-size: ${rem(12)};
  font-weight: ${props => props.theme.font.primary.weight.bold};
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
  box-shadow: 0 ${rem(1)} ${rem(4)} rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  max-width: ${rem(200)};
  overflow: hidden;
  text-overflow: ellipsis;
`

const PinSvg = styled.svg`
  .pin-body {
    fill: ${props => props.theme.palette.highlight.secondary.normalForeground};
  }
`

interface Props {
  label?: string
}

function PointOfInterestMarker({ label }: Props) {
  return (
    <Wrapper>
      <PinSvg
        width="24"
        height="36"
        viewBox="0 0 27 41"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="pin-body"
          d="M13.5 0C6.044 0 0 6.044 0 13.5C0 23.625 13.5 41 13.5 41S27 23.625 27 13.5C27 6.044 20.956 0 13.5 0Z"
        />
        <circle cx="13.5" cy="13.5" r="5.5" fill="#ffffff" />
      </PinSvg>
      {label && <Label>{label}</Label>}
    </Wrapper>
  )
}

export default memo(PointOfInterestMarker)
